import artistFrag from "./Artist";
import instanceFrag from "./Instance";
import WarehouseCategory from "./WarehouseCategory";
import warehouseMoveFrag from "./WarehouseMove";
import WarehousePacking from "./WarehousePacking";
import WarehouseWeightType from "./WarehouseWeightType";

const WarehouseItem = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  // Empty object {} means optimized mode (only id), true means include all defaults
  const includeDefaults = props === true;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    artist = false,
    artistId = includeDefaults,
    category = false,
    categoryId = includeDefaults,
    container = includeDefaults,
    description = includeDefaults,
    destroyed = includeDefaults,
    dimh = includeDefaults,
    dimw = includeDefaults,
    dimd = includeDefaults,
    externalRef = includeDefaults,
    image = includeDefaults,
    instance = false,
    instanceId = includeDefaults,
    itemDescription = includeDefaults,
    itemSite = false,
    link = includeDefaults,
    mgroup = includeDefaults,
    notes = includeDefaults,
    packing = includeDefaults,
    packingId = includeDefaults,
    responsibleGroupId = includeDefaults,
    weight = includeDefaults,
    warehouseMoves = false,
    weightType = false,
    weightTypeId = includeDefaults,
  } = propsObj;

  return `
  id
  ${
    artist
      ? `artist {
      ${artistFrag(artist)}
    }`
      : ""
  }
  ${artistId ? "artistId" : ""}
  ${
    category
      ? `category {
      ${WarehouseCategory}
    }`
      : ""
  }
  ${categoryId ? "categoryId" : ""}
  ${container ? "container" : ""}
  ${description ? "description" : ""}
  ${destroyed ? "destroyed" : ""}
  ${dimh ? "dimh" : ""}
  ${dimw ? "dimw" : ""}
  ${dimd ? "dimd" : ""}
  ${externalRef ? "externalRef" : ""}
  ${image ? "image" : ""}
  ${
    instance
      ? `instance {
      ${instanceFrag(instance)}
    }`
      : ""
  }
  ${instanceId ? "instanceId" : ""}
  ${itemDescription ? "itemDescription" : ""}
  ${
    itemSite
      ? `itemSite {
      ${warehouseMoveFrag(itemSite)}
    }`
      : ""
  }
  ${link ? "link" : ""}
  ${mgroup ? "mgroup" : ""}
  ${notes ? "notes" : ""}
  ${packing ? `packing {
    ${WarehousePacking}
  }` : ""}
  ${packingId ? "packingId" : ""}
  ${responsibleGroupId ? "responsibleGroupId" : ""}
  ${
    warehouseMoves
      ? `warehouseMoves {
      ${warehouseMoveFrag(warehouseMoves)}
    }`
      : ""
  }
  ${weight ? "weight" : ""}
  ${
    weightType
      ? `weightType {
      ${WarehouseWeightType}
    }`
      : ""
  }
  ${weightTypeId ? "weightTypeId" : ""}
`;
};

export default WarehouseItem;
